<template>
    <div>
        <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
            <el-tab-pane :label="$t('getapi[13227]')"><!-- 工程分析信息导入 -->
                <el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
                    <el-col :span="12">
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadurl"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChange"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :file-list="fileList"
                                :limit="1"
                        >
                            <el-button slot="trigger" size="small" type="primary" >{{$t('getapi[6422]')}}</el-button>
                            <div slot="tip" class="el-upload__tip">{{$t('getapi[6484]')}}</div>
                        </el-upload>
                    </el-col>
                    <el-col :span="12" align="right">
                        <el-button type="primary" size="small" @click="download">{{$t('getapi[6506]')}}</el-button>
                        <el-button type="primary" size="small" @click="delline">{{$t('getapi[686]')}}</el-button>
                        <el-button @click="okbtn" size="small" type="success" :loading="loading" style="margin-left:5px">{{$t('getapi[370]')}}</el-button>
                    </el-col>
                </el-row>
                <vxe-table 
                    :data="datajson" 
                    size="mini" 
                    ref='datajsonTable'
                    :loading="loading" 
                    :height="tableHeight" 
                    stripe border  
                    resizable 
                    :header-cell-style="$limits.headerClass" >
                    <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="errormsg" :title="$t('getapi[357]')" width="150px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="mevt_no"   :title="$t('getapi[463]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="iswork" :title="$t('getapi[8257]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="machingprocess" :title="$t('getapi[8503]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="machingremarks" :title="$t('getapi[8504]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="psm_minute" :title="$t('getapi[13191]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="omm_minute" :title="$t('getapi[13192]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="gr_minute" :title="$t('getapi[13193]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="dril_minute" :title="$t('getapi[13194]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="tapping_minute" :title="$t('getapi[13195]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="wedm_ms_minute" :title="$t('getapi[13196]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="wedm_hs_minute" :title="$t('getapi[13197]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="cnc_milling_minute" :title="$t('getapi[13198]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="cnc_one_minute" :title="$t('getapi[13199]')" width="120px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="cnc_two_minute" :title="$t('getapi[13201]')" width="120px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="cnc_minute" :title="$t('getapi[13202]')" width="80px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="cnc_gantry_minute" :title="$t('getapi[13203]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="gmc_minute" :title="$t('getapi[13204]')" width="120px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="cnc_precision_minute" :title="$t('getapi[13205]')" width="100px"></vxe-table-column>
                </vxe-table>
            </el-tab-pane>           

            <el-tab-pane :label="$t('getapi[13228]')"><!-- 询价分析信息导入 -->
                <el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
                    <el-col :span="12">
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadurlliu"
                                :on-preview="handlePreviewliu"
                                :on-remove="handleRemoveliu"
                                :on-change="handleChangeliu"
                                :on-success="handleSuccessliu"
                                :on-error="handleErrorliu"
                                :file-list="fileListliu"
                                :limit="1"
                        >
                            <el-button slot="trigger" size="small" type="primary" >{{$t('getapi[6422]')}}</el-button>
                            <div slot="tip" class="el-upload__tip">{{$t('getapi[6484]')}}</div>
                        </el-upload>
                    </el-col>
                    <el-col :span="12" align="right">
                        <el-button type="primary" size="small" @click="downloadliu">{{$t('getapi[6506]')}}</el-button>
                        <el-button type="primary" size="small" @click="dellineliu">{{$t('getapi[686]')}}</el-button>
                        <el-button @click="okbtnliu" size="small" type="success" :loading="loading" >{{$t('getapi[370]')}}</el-button>
                    </el-col>
                </el-row>
                <!-- 表格 -->
                <vxe-table 
                    :data="datajsonliu" 
                    ref='datajsonliuTable'
                    size="mini" 
                    :loading="loading" 
                    :height="tableHeight" 
                    stripe border  
                    resizable 
                    :header-cell-style="$limits.headerClass">
                    <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="errormsg" :title="$t('getapi[357]')" width="150px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="mevt_no" :title="$t('getapi[463]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="material" :title="$t('getapi[13207]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="gross_weight" :title="$t('getapi[13208]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="unit_price" :title="$t('getapi[13209]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="material_cost" :title="$t('getapi[13210]')" width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="enquiryprice_tax" :title="$t('getapi[13211]')" width="100px"></vxe-table-column>
                </vxe-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name: 'engmevtviewxp',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight- 220
            },
        },
        data() {
            return {
                fileList: [],
                fileListliu: [],
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                datajsonliu: [],
                loading: false, // 主表加载状态
                uploadurl: '',
                uploadurlliu: '',
                drolist: [],
                drolistliu: [],
                drosele: 0,
                droseleliu: 0,
                total1: 0,               
                rowindex: -1,
                wcentervisible: false,
                wcrowindex: -1,
                scrollTop:0,
                scrollTop1:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            let LanType=0;
            let language='';			
            language=window.localStorage.getItem('lang');
            if(language=='zh'){
                LanType=1;
            }else if(language=='en'){
                LanType=2;
            }else if(language=='hu'){
                LanType=3;
            }

            that.uploadurl = Common.Url + 'Eng/MEvtManage/EngMEvtEAToUpFile?token=' + token;
            that.uploadurlliu = Common.Url + 'Eng/MEvtManage/EngMEvtIAToUpFile?token=' + token;
            
        },
        mounted() {
            console.log('mounted');
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            btnauthority() {
                let that = this;
                // 权限
            },
            //删除行
            delline() {
                let that = this;
                let selectRecords = this.$refs.datajsonTable.getCheckboxRecords();
                for(let i=selectRecords.length-1;i>=0;i--){
                    let line = this.$refs.datajsonTable.getRowIndex(selectRecords[i]);
                    that.datajson.splice(line, 1);
                }
            },
            dellineliu() {
                let that = this;
                let selectRecordliu = this.$refs.datajsonliuTable.getCheckboxRecords();
                for(let i=selectRecordliu.length-1;i>=0;i--){
                    let line = this.$refs.datajsonliuTable.getRowIndex(selectRecordliu[i]);
                    that.datajsonliu.splice(line, 1);
                }
            },         
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        that.datajson = file.response.DataContent;
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.datajson = res.DataContent;
                }
                that.fileList = [];
                that.$refs.upload.clearFiles();
            },
            handleError(err, file, fileList) {
                let that = this;
                // that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },    
            handleErrorliu(err, file, fileListliu) {
                let that = this;
                // that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },         
            handleChangeliu(file, fileListliu) {
                let that = this;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                    } else {
                        that.datajsonliu = file.response.DataContent;
                    }
                    that.$refs.upload.clearFiles();
                }
            },
            handleSuccessliu(res, file, fileListliu) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.datajson = res.DataContent;
                }
                that.fileListliu = [];

            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handleRemoveliu(file, fileListliu) {
                console.log(file, fileListliu);
            },            
            handlePreview(file) {
                console.log("handlePreview" + file);
            },
            handlePreviewliu(file) {
                console.log("handlePreviewliu" + file);
            },
            
            download(){
                let param={
                    url:'/Eng/MEvtManage/EngMEvtEATemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            downloadliu(){
                let param={
                    url:'/Eng/MEvtManage/EngMEvtIATemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            // 保存数据
            okbtn() {
                let that = this;
                that.loading = true;                
                let parm =  that.datajson;
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/MEvtManage/EngMEvtEAToImportSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[818]'));
                    }
                    else if (res.Success == -2) {
                        that.datajson = res.DataContent.dt;
                    }
                    that.loading = false;
                });
            },
            // 
            okbtnliu() {
                let that = this;            
                that.loading = true;
                let parm = that.datajsonliu;
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/MEvtManage/EngMEvtIAToImportSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[818]'));
                    }
                    else if (res.Success == -2) {
                        that.datajsonliu = res.DataContent.dt;
                    }
                    that.loading = false;
                });
                
            },
        }
    };
</script>

<style lang="scss" scoped>
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
</style>
